// ErrorBoundary — chytí chybu v paneli/module, aby jedna chyba NIKDY nezhodila
// celý Matrix na bielu obrazovku (ústava 2/4 „nič nevisí"). React vyžaduje class komponent.
import React from 'react'
import { COLORS, TYPO, SPACE, RADIUS } from '../theme.js'

export default class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { err: null } }
  static getDerivedStateFromError(err) { return { err } }
  componentDidCatch(err, info) {
    try { console.error('[ErrorBoundary]', this.props.label || '', err, info && info.componentStack) } catch (_) {}
  }
  render() {
    if (this.state.err) {
      const e = this.state.err
      const head = String((e && (e.name ? (e.name + ': ' + (e.message || '')) : (e.message || e))) || 'Neznáma chyba')
      const detail = String((e && e.stack) || '')
      return (
        <div style={{ padding: SPACE.lg, margin: SPACE.md, background: '#fef2f2', border: `1px solid ${COLORS.remove}`, borderRadius: RADIUS.md, color: '#991b1b', fontSize: TYPO.sizes.sm }}>
          <div style={{ fontWeight: 800, marginBottom: 6, fontSize: TYPO.sizes.md }}>
            Chyba v paneli{this.props.label ? ` „${this.props.label}"` : ''} — zvyšok Matrixu funguje normálne.
          </div>
          <div style={{ marginBottom: 8 }}>Skús <b>načítať panel znova</b> alebo prepni tab a späť. Ak pretrváva, pošli mi tento text:</div>
          <div style={{ fontWeight: 800, color: '#b91c1c', background: '#fff', border: `1px solid ${COLORS.remove}`, borderRadius: 6, padding: '8px 10px', marginBottom: 10, fontSize: TYPO.sizes.sm, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{head}</div>
          <button onClick={() => this.setState({ err: null })}
            style={{ padding: '7px 16px', border: 'none', borderRadius: RADIUS.sm, background: COLORS.nav, color: '#fff', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>
            ↻ Načítať panel znova
          </button>
          <pre style={{ marginTop: 12, fontSize: 11, whiteSpace: 'pre-wrap', wordBreak: 'break-word', color: '#7f1d1d', background: 'rgba(0,0,0,0.04)', padding: 8, borderRadius: 6, maxHeight: 160, overflow: 'auto' }}>{detail}</pre>
        </div>
      )
    }
    return this.props.children
  }
}
